import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import { useRoute, useRouter } from "vue-router"
import { chatsStore } from "@/store/chats"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderLogo',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const onLogoClick = () => {
	chatsStore().setMode('list')
	chatsStore().setOpenedChat(null)
	if (route.path === '/main' && route.query.page === 'chat' && route.query.mode === 'list') return
	router.push({
		path: '/main',
		query: {
			page: 'chat',
			mode: 'list'
		}
	})
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "header-logo",
    onClick: onLogoClick
  }, [
    _createVNode(AppIcon, {
      name: "logo",
      width: "123px",
      height: "24px"
    })
  ]))
}
}

})